import { Button, Group, Modal, Select, Space, Text } from "@mantine/core";
import { Timestamp } from "firebase/firestore";
import { Dispatch, SetStateAction, useCallback, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { useGetAuthorizations } from "@/hooks/useGetAuthorizations";
import { ID_EXTRAS_ALTERAR_FASE_DA_EMPRESA } from "@/utils/constants";
import { TStatusForm } from "../../../firestore";
import { useStatus } from "../hooks/useStatus";

const changeStatus = (
  selects: TEmpresa[],
  mutate: (item: TStatusForm) => void,
  id: string | undefined,
  status: string,
  setReload: Dispatch<SetStateAction<boolean>>,
  setOpenModal: Dispatch<SetStateAction<boolean>>
) => {
  return () => {
    selects.map((item: TEmpresa & StatusItem) =>
      mutate({
        id: item?.statusItem?.id,
        updatedAt: Timestamp.now(),
        idEmpresa: item?.id || "",
        idProjeto: id || "",
        status: status || "",
        createdAt: Timestamp.now(),
        deletedAt: null
      })
    );
    setReload((reload) => !reload);
    setOpenModal(false);
  };
};

interface StatusItem {
  statusItem: TStatus;
}

interface Fase {
  id: string;
  cor: string;
  titulo: string;
}

// prettier-ignore
const StatusComponente = ({ selects, setReload, fases }: { selects: TEmpresa[], setReload: Dispatch<SetStateAction<boolean>>, fases: Fase[] | undefined }) => {
  const [openModal, setOpenModal] = useState<boolean>(false)
  const [fase, setFase] = useState("")
  const { mutate } = useStatus();
  const { id } = useParams<{ id: string }>();
  const autorizacao = useGetAuthorizations(ID_EXTRAS_ALTERAR_FASE_DA_EMPRESA);

  const changeModal = useCallback(() => {
    setOpenModal((open) => !open)
  }, [])

  const onChange = useCallback((value: string | null) => {
    setFase(value ?? "")
  }, [])

  const faseOptions = useMemo(
    () => fases?.map((item) => ({ value: item.id, label: item.titulo })) ?? [],
    [fases]
  )

  const handleSave = useMemo(
    () => changeStatus(selects, mutate, id, fase, setReload, setOpenModal),
    [fase, id, mutate, selects, setReload]
  )

  return <>
    {autorizacao.read && selects && selects.length > 0 && <Button onClick={changeModal} color="rgba(8, 68, 244, 1)">Alterar fase</Button>}
    <Modal opened={openModal} onClose={changeModal}>
      <Text fw="bold" mb="md">
        Alterar fase
      </Text>
      <Select
        placeholder="Selecione uma fase"
        data={faseOptions}
        onChange={onChange}
        value={fase}
      />
      <Space h="xl" />
      <Group justify="flex-end">
        <Button type="submit" variant="filled" onClick={handleSave}>
          Salvar
        </Button>
      </Group>
    </Modal>
  </>
};

export default StatusComponente;
